import styled, { breakpoints, css, Device, Scale, StyledComponent } from '@se-admin/falcon';

export const ExpiredSalePageWrapper: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    & > * {
      margin-bottom: ${Scale.xl};
    }
  `;
});

export const RecomendationWrapper: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    @media (max-width: ${breakpoints[Device.tablet]}) {
      margin-top: ${Scale.m};
    }
  `;
});
